<template>
    <div>
        <div v-for="x in currentVisibleCount">
            <slot :name="slotName(x)"></slot>
        </div>

        <button
            class="btn btn-default"
            type="button"
            @click="addClick"
            v-if="currentVisibleCount < count"
        >
            Add Another {{ addAnotherLabel }}
        </button>
        <button
            class="btn btn-default"
            type="button"
            @click="removeClick"
            v-if="currentVisibleCount > 1 "
        >
            Remove One {{ addAnotherLabel }}
        </button>
    </div>
</template>

<script>
  export default {
    props: ['count', 'visibleCount', 'addAnotherLabel'],
    data: () => ({
      currentVisibleCount: 0,
    }),
    methods: {
      slotName(i) {
        return 'slot_' + i;
      },
      addClick() {
        this.currentVisibleCount++
        this.$emit('click',this.currentVisibleCount)
      },
      removeClick() {
        this.currentVisibleCount--
        this.$emit('click',this.currentVisibleCount)
      }
    },
    created() {
      this.currentVisibleCount = this.visibleCount;
    }
  }
</script>
